import { Component, OnInit } from "@angular/core";
import { first } from "rxjs/operators";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import * as Highcharts from "highcharts";
import { DashboardDirectionJuridiqueService } from "../../core/service/dashboard-direction-juridique.service";
import { ChartViewDTO } from "../../core/model/chart_view/chart-view-dto";
import { SlaProduitDTO } from "../../core/model/sla-produit-dto";
import { DurationByProduitDTO } from "../../core/model/duration-by-produit-dto";
import { DurationByTaskDTO } from "../../core/model/duration-by-task-dto";
import { DashboardAllDirectionService } from '../../core/service/dashboard-all-direction.service';

@Component({
  selector: "app-quality-of-service",
  templateUrl: "./quality-of-service.component.html",
  styleUrls: ["./quality-of-service.component.scss"],
  
  //
  animations: [
    trigger("detailExpand", [
      state("collapsed", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
  //

})
export class QualityOfServiceComponent implements OnInit {
  
  codeDirection : String = 'DIRECTION_RISQUE';
  highcharts = Highcharts;
  chartOptionsSlaPeriodeParProduit: any;
  chartOptionsSlaPeriodeParProfile: any;
  slaPeriodeParProduit: ChartViewDTO;
  slaPeriodeParProfile: ChartViewDTO;

  //slaProduitDTOs: SlaProduitDTO[];

  durationByProduitDTOs: DurationByProduitDTO[];
  displayedProduitColumnsList: string[] = [
    "codeProduit",
    "duration",
    "actions",
  ];
  durationByTaskDTOs: DurationByTaskDTO[];
  durationByTaskDTOArray: Array<DurationByTaskDTO[]> = [];

  constructor(
    private _dashboardAllDirectionService: DashboardAllDirectionService
  ) {}

  ngOnInit() {
    this.getSlaPeriodeParProduit(this.codeDirection);
    this.getSlaPeriodeParProfile(this.codeDirection);
    //this.getSlaProduit(this.codeDirection);
    this.durationProduit(this.codeDirection);
  }

  getSlaPeriodeParProduit(codeDirection) {
    this._dashboardAllDirectionService
      .slaPeriodeParProduit(codeDirection)
      .pipe(first())
      .subscribe(
        (response) => {
          this.slaPeriodeParProduit = response;

          this.chartOptionsSlaPeriodeParProduit = {
            chart: {
              type: "spline",
            },
            title: {
              text: "Temps de traitement par produit",
            },
            subtitle: {
              text: null,
            },
            xAxis: {
              categories: this.slaPeriodeParProduit.categories,
            },
            yAxis: {
              title: {
                text: "Jours",
              },
            },
            tooltip: {
              valueSuffix: null,
            },

            legend: {
              layout: "vertical",
              align: "right",
              verticalAlign: "top",
              x: 0,
              y: 100,
              floating: false,
              borderWidth: 1,

              backgroundColor: "#FFFFFF",
              shadow: true,
            },

            series: this.slaPeriodeParProduit.series,
          };
        },
        (error) => {
          console.log(error);
        }
      );
  }

  getSlaPeriodeParProfile(codeDirection) {
    this._dashboardAllDirectionService
      .slaPeriodeParProfile(codeDirection)
      .pipe(first())
      .subscribe(
        (response) => {
          this.slaPeriodeParProfile = response;

          this.chartOptionsSlaPeriodeParProfile = {
            chart: {
              type: "spline",
            },
            title: {
              text: "Temps de traitement par profil",
            },
            subtitle: {
              text: null,
            },
            xAxis: {
              categories: this.slaPeriodeParProfile.categories,
            },
            yAxis: {
              title: {
                text: "Jours",
              },
            },
            tooltip: {
              valueSuffix: null,
            },

            legend: {
              layout: "vertical",
              align: "right",
              verticalAlign: "top",
              x: 0,
              y: 100,
              floating: false,
              borderWidth: 1,

              backgroundColor: "#FFFFFF",
              shadow: true,
            },

            series: this.slaPeriodeParProfile.series,
          };
        },
        (error) => {
          console.log(error);
        }
      );
  }

  
  /*getSlaProduit(codeDirection) {
    this._dashboardAllDirectionService
      .slaProduit(codeDirection)
      .pipe(first())
      .subscribe(
        (response) => {
          this.slaProduitDTOs = response;
        },
        (error) => {
          console.log(error);
        }
      );
  }*/

  durationProduit(codeDirection) {
    this._dashboardAllDirectionService.durationProduit(codeDirection).subscribe(
      (data) => {
        this.durationByProduitDTOs = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  durationTask(codeProduit) {
    this._dashboardAllDirectionService
      .durationTask(this.codeDirection,codeProduit)
      .subscribe(
        (data) => {
          this.durationByTaskDTOs = data;
          this.durationByTaskDTOArray[codeProduit] = this.durationByTaskDTOs;
        },
        (error) => {
          console.log(error);
        }
      );
  }

}
